import Vue from 'vue';
import Vuex from 'vuex';

import currentTournament from './modules/currentTournament';
import bracket from './modules/bracket';
import currentUser from "./modules/CurrentUser";

Vue.use(Vuex);
export default new Vuex.Store({
    modules:{
        currentTournament,
        bracket,
        currentUser,
    }
});